import { render, staticRenderFns } from "./ParecerFinanceiroForm.vue?vue&type=template&id=84f5b4e2"
import script from "./ParecerFinanceiroForm.vue?vue&type=script&lang=js"
export * from "./ParecerFinanceiroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports